import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import OpenKnotsContainer from './OpenKnotsContainer';
import NotFound from '../NotFoundPage';
import NotAuthorizedPage from '../NotAuthorizedPage';
import AuthContext from '../../store/AuthContext';
import { isOpenKnotsEnvEnabled } from '../../config/openKnotsFeature';
import { useBuyerKnotTabs } from '../../hooks/useBuyerKnotTabs';
import { openKnotsCopy } from '../../utils/constants/openKnotsLabel';
import { isOpenKnotsHostPath } from '../../config/openKnotsHostPaths';

function OpenKnotsOrNotFound() {
    const location = useLocation();
    const ctx = useContext(AuthContext);
    const knotTabs = useBuyerKnotTabs(ctx.userData);
    const isOpenKnotsPath = isOpenKnotsHostPath(location.pathname);

    if (!isOpenKnotsPath) {
        return <NotFound />;
    }

    const isBuyer =
        ctx.userData?.user_organizations?.[0]?.user_org_role_maps?.[0]?.platform_role === 'buyer';
    const isSupplier =
        ctx.userData?.user_organizations?.[0]?.user_org_role_maps?.[0]?.platform_role === 'supplier';

    if (isBuyer || isSupplier) {
        if (knotTabs.loading) {
            return null;
        }
        if (knotTabs.loaded && !knotTabs.hasAnyAccess) {
            return (
                <NotAuthorizedPage
                    title="You don't have access"
                    message={openKnotsCopy(
                        "You don't have access to BAAS, Trade Support Program, or {openKnots} for your organization. If you believe this is a mistake, please contact your administrator."
                    )}
                    showBackLink={false}
                />
            );
        }
        if (!knotTabs.isVisible('openKnots')) {
            return (
                <NotAuthorizedPage
                    title='403 — Not authorized'
                    message={openKnotsCopy(
                        '{openKnots} is not enabled for your organization. If you believe this is a mistake, contact your administrator.'
                    )}
                />
            );
        }
        return <OpenKnotsContainer knotTabVisibility={knotTabs.visibility} />;
    }

    if (!isOpenKnotsEnvEnabled()) {
        return <NotFound />;
    }

    return <OpenKnotsContainer />;
}

export default OpenKnotsOrNotFound;
